<style scoped>
.xo-img-list{
  display: inline-block;
  width: 100%;
  height: 120px;
  cursor: pointer;
  margin-bottom: 30px;
}
.xo-img-list:hover{
  border: 2px solid #39f;
}
.xo-img-list-active{
  border: 3px solid #2d8cf0;
}

.xo-img-list img {
  width: 100%;
  height: 100%;
}
</style>

<template>
  <div>
    <p class="text-center text-14">小欧匹配结果选择</p>
    <p class="remark">* 根据您设置的条件，匹配相似度大于 {{searchModel.score}} %的画面如下，供参考。
点击画面可查看画面对应的点位信息以及发布历史，点击“重置匹配条件”即可返回到配置页面</p>
    <Divider style="margin: 10px 0;"/>

    <p v-if="imgList.length===0" class="text-center remark m-t-50 m-b-50">暂无数据，请“重置匹配条件”</p>
    <template v-else>
      <div
        class="xo-img-list"
        :class="selectImgUrl===item.filePath?'xo-img-list-active':''"
        v-for="(item, index) in imgList"
        :key="'default_' + index"
        @click="handleSelectImg(item)"
      >
        <img :src="item.filePath + '?x-oss-process=image/resize,h_120'">
        <p class="m-b-10"><span class="remark">上刊品牌/画面：</span>  {{ item.brandName !== 'null'? item.brandName : item.fileName }}</p>
      </div>
      <div class="paging_style">
          <Page size="small" :total="total" :page-size="searchModel.pageSize" :current="searchModel.pageNumber"
            show-total show-elevator  @on-change="handlePageNumberChange"></Page>
      </div>
    </template>

    <Divider style="margin: 10px 0;"/>
    <Row>
      <i-col span="12">
        <Button type="primary" @click="handlePrevious">重置匹配条件</Button>
      </i-col>
    </Row>

    <Spin v-if="showSpin" fix>
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>努力加载中...</div>
    </Spin>
  </div>
</template>

<script>
import { getSearchResultList } from '@/api/msp/search'

export default {
  data () {
    return {
      imgList: [],
      selectImgUrl: '',

      showSpin: false,
      searchModel: {},
      total: 0
    }
  },
  methods: {
    initPageData (params) {
      this.showSpin = true
      this.searchModel = params

      getSearchResultList(this.searchModel).then(res => {
        this.showSpin = false
        this.imgList = res.list
        this.total = res.totalRow

        if (this.imgList.length > 0) {
          this.handleSelectImg(this.imgList[0])
        }
      })
    },
    handlePageNumberChange (page) {
      this.searchModel.pageNumber = page
      this.initPageData(this.searchModel)
    },
    handlePrevious (params) {
      this.$emit('on-prev')
    },
    handleSelectImg (img) {
      this.selectImgUrl = img.filePath
      this.$emit('on-load-resource', img)
    }
  }
}
</script>
